/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_Stat_3_LabelInputs */

const tr_landing_intro_stat_3_label = /** @type {(inputs: Landing_Intro_Stat_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ek modül, ek lisans`)
};

const en_landing_intro_stat_3_label = /** @type {(inputs: Landing_Intro_Stat_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra modules, extra licenses`)
};

const de_landing_intro_stat_3_label = /** @type {(inputs: Landing_Intro_Stat_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusatzmodule, Zusatzlizenzen`)
};

const ru_landing_intro_stat_3_label = /** @type {(inputs: Landing_Intro_Stat_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доп. модули и лицензии`)
};

/**
* | output |
* | --- |
* | "Extra modules, extra licenses" |
*
* @param {Landing_Intro_Stat_3_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_stat_3_label = /** @type {((inputs?: Landing_Intro_Stat_3_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_Stat_3_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_stat_3_label(inputs)
	if (locale === "de") return de_landing_intro_stat_3_label(inputs)
	if (locale === "ru") return ru_landing_intro_stat_3_label(inputs)
	return tr_landing_intro_stat_3_label(inputs)
});